import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { ThemeColor, themeColors } from 'app/styles/theme';
import {
  isInArray,
  PropsOf,
  StringOr,
} from 'app/tools/general.types';
import { colorToHex } from 'app/tools/utils';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { Merge } from 'type-fest';
import Button from '../button/Button';
import Icon from '../icon/Icon';

const StyledCard = styled.div<{ $background: string }>`
  display: flex;
  justify-content: center;
  ${styledMixins.roundCorners}
  ${styledMixins.softShadowSmall}
  background-color: ${p => p.$background};
  align-items: center;
  width: 50px;
  height: 50px;
`;

const StyledButton = styled(Button)<{ $cssColor?: string }>`
  min-width: auto;
  &:not(:last-child) {
    margin-right: ${styledFuncs.pad()};
  }
  ${p =>
    p.$cssColor &&
    css`
      color: ${p.theme.palette.getContrastText(
        colorToHex(p.$cssColor)
      )};
    `}
`;

type Props = Merge<
  PropsOf<typeof Button>,
  {
    color?: StringOr<ThemeColor>;
    alt: string;
    imgNode: React.ReactNode;
  }
>;

export default function CardIconButton({
  color,
  alt,
  imgNode,
  ...p
}: Props): JSX.Element {
  const themeColor = isInArray(color, themeColors)
    ? color
    : 'default';
  const cssColor = !isInArray(color, themeColors)
    ? color || 'white'
    : color === 'default'
    ? 'white'
    : undefined;

  return (
    <StyledButton
      plain
      asSpan
      color={themeColor}
      $cssColor={cssColor}
      {...p}
    >
      {/* If color is not specified, or is set to 'default', card will
      be opaque (and white if no color). Otherwise, card will be
      transparent to allow button color to come through */}
      <StyledCard $background={cssColor || 'transparent'}>
        <Icon size={32} {...{ alt, imgNode }} />
      </StyledCard>
    </StyledButton>
  );
}
